import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import PreLoginPage from '../../../views/core/PreLoginPage';

// ES6 class-style
class Featured extends PreLoginPage {
  render() {
  	return(
	<div data-p-ga="" className="featured">
		<div className="container">
			<h3>Featured In</h3> 
			<div className="row justify-content-center">
				<div className="col-md-8">
					<div className="books">
						<a data-ga="Home - Featured In - BBC News" href="http://news.bbc.co.uk/2/hi/south_asia/5203440.stm" target="_blank"><img src="../img/BBCNews.png" alt="" /></a>
						<a data-ga="Home - Featured In - NewYork Times" href="https://www.nytimes.com/2005/09/16/opinion/still-eating-our-lunch.html?_r=1" target="_blank"><img src="../img/Newyorktimes.png" alt="" /></a>
						<a data-ga="Home - Featured In - World is Flat" href={this.getUrlFor("IFRAME_DOMAIN")+"/staticfiles/Thomas-FriedMan.pdf"} target="_blank"><img src="../img/Friedman.png" alt="" /></a>
						<a data-ga="Home - Featured In - NASSCOM" href={this.getUrlFor("IFRAME_DOMAIN")+"/staticfiles/NASSCOM-Award.png"} target="_blank"><img src="../img/Nasscom.png" alt="" /></a>
					</div>
				</div>
			</div>
		</div>
	</div>
  	);
  }
}

export default Featured;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/Featured.js